import "angular";
import "angular-resource";
import AuthenticationStatusService from "../authentication/AuthenticationStatusService";
import LanguageCodeFactory from "../layout/service/factory/LanguageCodeFactory";
import PrimaryPlanTxnAccessService from "../layout/service/primaryPlanTxnAccessService";
import TransactionAccessRetrService from "../layout/service/TransactionAccessRetrService";
import PrimaryPlanFactory from "../plan/PrimaryPlanFactory.js";

import AccountDetailsFactory from "./AccountDetailsFactory";
import AccountListFactory from "./AccountListFactory";
import AccountService from "./AccountService";

const AccountServiceModule = angular
    .module("AccountServiceModule", ["ngResource"])
    .service("accountService", AccountService)
    .factory("accountListFactory", AccountListFactory)
    //Possibly can deprecate accountDetailsFactory
    .factory("accountDetailsFactory", AccountDetailsFactory)
    .factory("LanguageCodeFactory", LanguageCodeFactory)
    .factory("AuthenticationStatusService", AuthenticationStatusService)
    .factory("primaryPlanFactory", PrimaryPlanFactory)
    .factory("TransactionAccessRetrService", TransactionAccessRetrService)
    .factory("PrimaryPlanTxnAccessService", PrimaryPlanTxnAccessService);

export default AccountServiceModule;
